import { render, staticRenderFns } from "./ManageUsersDetailsView.vue?vue&type=template&id=2f34bd98&"
import script from "./ManageUsersDetailsView.vue?vue&type=script&lang=ts&"
export * from "./ManageUsersDetailsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports